import {
  publicHttpClient,
  type AxiosRequestConfig,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

export interface OrderHistoryResponse {
  orders: Order[];
}

export interface Order {
  code: string;
  status: string;
  delivery_order_id: string;
  subtotal: number;
  total_payment: number;
  store_id: number;
  store_name: string;
  create_at: number;
  rating_summary: {
    overall: number;
    comment?: string;
    tags?: string[];
  };
  store_image_url?: string;
}
export const getOrderHistoryFn = async (
  token: string,
  skip = 0,
  limit = 20,
  config: AxiosRequestConfig = {}
): Promise<OrderHistoryResponse> => {
  const response = await publicHttpClient.get<OrderHistoryResponse>(
    apiRoutes.ahafood.store.get_order_history,
    {
      params: { skip, limit },
      headers: { Authorization: `Bearer ${token}` },
      ...config,
    }
  );
  return response.data;
};

export const useGetOrderHistory = (
  token: string,
  skip = 0,
  limit = 20,
  opts?: Omit<
    UseQueryOptions<OrderHistoryResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<OrderHistoryResponse, Error>({
    queryKey: [apiRoutes.ahafood.store.get_order_history],
    queryFn: () => getOrderHistoryFn(token, skip, limit),
    ...opts,
  });
};
